import type { AgentMetrics, CallSourceInfo, VoiceSource } from '../types/voip';

export const callSources: CallSourceInfo[] = [
  { id: 'voip', label: 'VoIP', description: 'Desk & softphones' },
  { id: 'five9', label: 'Five9', description: 'Contact center' },
  { id: 'bland', label: 'Bland', description: 'AI dialer' },
];

/** Fraction of each human-call metric that flows through each voice source (sums to 1) */
export const voiceShares: Record<VoiceSource, AgentMetrics> = {
  voip: { outbound: 0.7, inbound: 0.42, missed: 0.35, talkSeconds: 0.52 },
  five9: { outbound: 0.3, inbound: 0.58, missed: 0.65, talkSeconds: 0.48 },
};
